import { Plus } from 'lucide-react';
import { CICLOS_VIDA_BASE } from '../constants';
import { processarTextoColado } from '../utils/text-processor';
import { useI18n } from '@/contexts/i18n-hook';

interface CicloVidaSectionProps {
  ciclosVida: string[];
  novoCicloVida: string;
  setCiclosVida: (ciclos: string[]) => void;
  setNovoCicloVida: (ciclo: string) => void;
}

export function CicloVidaSection({
  ciclosVida,
  novoCicloVida,
  setCiclosVida,
  setNovoCicloVida,
}: CicloVidaSectionProps) {
  const { t } = useI18n();
  const adicionarCicloVida = () => {
    if (novoCicloVida.trim() && !ciclosVida.includes(novoCicloVida.trim())) {
      setCiclosVida([...ciclosVida, novoCicloVida.trim()]);
      setNovoCicloVida('');
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {t('apreciacaoModais.editarParte.cicloVida.titulo')}
      </label>
      <div className="flex flex-wrap gap-2 mb-3">
        {CICLOS_VIDA_BASE.map((ciclo) => (
          <button
            key={ciclo}
            type="button"
            onClick={() => {
              if (ciclosVida.includes(ciclo)) {
                setCiclosVida(ciclosVida.filter(c => c !== ciclo));
              } else {
                setCiclosVida([...ciclosVida, ciclo]);
              }
            }}
            className={`px-3 py-1 rounded-full text-sm ${
              ciclosVida.includes(ciclo)
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            {t(`apreciacaoModais.editarParte.cicloVida.opcao.${ciclo}`)}
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <input
          type="text"
          value={novoCicloVida}
          onChange={(e) => setNovoCicloVida(e.target.value)}
          onPaste={(e) => {
            e.preventDefault();
            const textoColado = e.clipboardData.getData('text');
            const textoProcessado = processarTextoColado(textoColado);
            setNovoCicloVida(textoProcessado);
          }}
          placeholder={t('apreciacaoModais.editarParte.cicloVida.placeholder')}
          className="flex-1 border border-gray-300 rounded-md px-3 py-2"
        />
        <button
          type="button"
          onClick={adicionarCicloVida}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          <Plus className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

